import Raven from 'raven-js';
import devLogger from 'react-utils/devLogger';
export const logError = error => {
  devLogger.warn({
    key: null,
    message: error
  });
  Raven.captureMessage(error);
};